import React from "react";
import { useDispatch, useSelector } from "react-redux";
import PropTypes from "prop-types";
import get from "lodash/get";
import { collectionToStories } from "@quintype/components";
import CollectionTitle from "../../atoms/CollectionTitle";
import { generateNavigateSlug, navigateTo } from "../../utils";
import { useDeviceType } from "../../custom-hooks/useDeviceType";
import ShowMoreButton from "../../atoms/ShowMoreButton";
import { RowSeparator } from "../../atoms/RowSeparator";
import { DfpComponent } from "../../ads/dfp-component";
import { OtherStories } from "./OtherStories";
import { StoryCard } from "./StoryCard";

import "./four-col-four-var-one.m.css";

export default function FourColumnFourStoriesVarOne({ config = {}, collection, extraProp = "" }) {
  const associatedMetadata = get(collection, ["associated-metadata"], {});

  const rowAdUnitBottom = associatedMetadata.show_row_ad_unit_bottom || null;
  const showColumnSeparator = associatedMetadata.show_column_separator || null;
  const showRowSeparator = associatedMetadata.show_row_separator || null;
  const showTimeStamp = associatedMetadata.show_timestamp || null;
  const showReadTime = associatedMetadata.show_read_time || null;
  const showSubheadline = associatedMetadata.show_sub_headline || null;
  const showRowTitle = associatedMetadata.show_row_title || null;
  const enableSponsorAd = associatedMetadata.enable_sponsor_ad || null;
  const sponsorAdDetails = associatedMetadata.sponsor_ad_details || null;
  const showMoreStories = associatedMetadata.show_more_stories || null;
  const isHeroStoryOnColumn4 = associatedMetadata.move_hero_story_to_column_4 || null;

  const deviceType = useDeviceType();
  const isDesktop = deviceType === "desktop";
  const isMobile = deviceType === "mobile";

  const sectionSlug = extraProp;

  const dispatch = useDispatch();
  const qtConfig = useSelector((state) => get(state, ["qt", "config"], {}));
  const url = generateNavigateSlug(collection, qtConfig);
  const bottomAdConfig = useSelector((state) =>
    get(state, ["qt", "config", "ads-config", "slots", "row_bottom_ad"], {})
  );
  const sponsorAdConfig = useSelector((state) => get(state, ["qt", "config", "ads-config", "slots", "sponsor_ad"], {}));
  const pageType = useSelector((state) => get(state, ["qt", "pageType"], null));
  const stories = collectionToStories(collection);

  if (!stories.length) return null;

  const [firstStory, ...otherStories] = stories;

  const getStyle = () => {
    let newStyle = "";
    if (!isHeroStoryOnColumn4) {
      newStyle = showColumnSeparator ? "stories-list-with-separator" : "stories-list";
    } else {
      newStyle = showColumnSeparator ? "move-herostory-list-with-separator" : "move-herostory-list";
    }
    return newStyle;
  };
  return (
    <div className="row-component" styleName="top-component-wrapper">
      <div styleName="four-col-four-var-one">
        {showRowTitle && (
          <CollectionTitle
            collection={collection}
            enableSponsorAd={enableSponsorAd}
            sponsorAdDetails={sponsorAdDetails}
            sectionSlug={sectionSlug}
            sponsorAdConfig={sponsorAdConfig}
          />
        )}
        <div styleName={isDesktop ? getStyle() : showColumnSeparator ? "stories-list-with-separator" : "stories-list"}>
          <div styleName="hero-story">
            <StoryCard
              story={firstStory}
              showTimeStamp={showTimeStamp}
              showReadTime={showReadTime}
              isHorizontal={!isMobile && true}
              isHeroStory={firstStory && true}
              showSubheadline={showSubheadline}
              sectionSlug={sectionSlug}
            />
          </div>
          {showColumnSeparator && otherStories.length > 0 && <div styleName="hero-divider"></div>}
          <OtherStories
            showColumnSeparator={showColumnSeparator}
            otherStories={otherStories}
            showTimeStamp={showTimeStamp}
            showReadTime={showReadTime}
            sectionSlug={sectionSlug}
          />
        </div>
        {stories.length > 0 && showMoreStories && (
          <ShowMoreButton
            collection={collection}
            config={config}
            navigate={() => navigateTo(dispatch, url)}
            qtConfig={qtConfig}
          />
        )}
      </div>
      {showRowSeparator && <RowSeparator />}
      {rowAdUnitBottom && (
        <DfpComponent
          adStyleName="ad-slot-size-300x250"
          id={`${pageType}-${collection.slug}-row-bottom-ad`}
          path={rowAdUnitBottom}
          size={bottomAdConfig.sizes}
          viewPortSizeMapping={bottomAdConfig.view_port_size_mapping}
        />
      )}
    </div>
  );
}

FourColumnFourStoriesVarOne.propTypes = {
  collection: PropTypes.shape({
    slug: PropTypes.string,
  }),
  stories: PropTypes.array.isRequired,
  config: PropTypes.object,
  extraProp: PropTypes.string,
};

FourColumnFourStoriesVarOne.storyLimit = 4;
